/*
 * MEN MANSION - Knappheits-Hinweise auf der PDP
 *
 * Zwei Aufgaben:
 *   1. Die Pille (Block 1a) in die ERSTE Galerie-Slide haengen. Nur dort: auf den
 *      Folge-Slides steht Typo im Bild, die das Overlay verdecken wuerde.
 *   2. Den Tooltip in der Buybox (Block 1c) auf Touch-Geraeten per Tap schalten.
 *      Auf Desktop macht das CSS das per :hover und :focus-within, hier passiert
 *      dafuer nichts.
 *
 * Die Pille liegt als Vorlage im Markup (<template id="mm-sc-pill-tpl">), damit die
 * Texte in Liquid stehen und nicht im JS.
 */
(function () {
  'use strict';

  /* ---------- 1. Overlay in jede Slide ---------- */
  function ziele() {
    // NICHT .product__media-wrapper nehmen: der umfasst auch die Thumbnail-Leiste,
    // eine Pille landete dort an deren Unterkante und lag 61px darueber.
    // Der richtige Anker ist das Medium selbst:
    //   .product__media-item > .product-media-container > … > img
    // Keine Hoehenpruefung: Die Thumbnails sind .thumbnail-list__item und werden
    // von diesem Selektor gar nicht getroffen. Auch verborgene Slides bekommen
    // ihre Pille, sonst fehlt sie nach einem Bildwechsel spaeter im Besuch.
    var raus = [];
    var items = document.querySelectorAll('.product__media-item');
    for (var i = 0; i < items.length; i++) {
      raus.push(items[i].querySelector('.product-media-container') || items[i]);
    }
    return raus;
  }

  function haengeAn(slide, el) {
    // absolute Positionierung braucht einen positionierten Vorfahren
    if (getComputedStyle(slide).position === 'static') slide.style.position = 'relative';
    slide.appendChild(el);
  }

  // Der Hinweis steht auf JEDEM Bild, nicht nur auf dem ersten: Mobil sind im
  // Scroll-Slider alle Slides sichtbar, und beim Durchwischen soll die Aussage
  // nicht verschwinden. Auf Desktop traegt sie dadurch die jeweils gezeigte
  // Slide, auch wenn der Koala-Gallery-Sync sie nach dem Laden wechselt.
  function setzePille() {
    var tpl = document.getElementById('mm-sc-pill-tpl');
    if (!tpl) return;
    var slides = ziele();
    for (var i = 0; i < slides.length; i++) {
      if (hatSchonPille(slides[i])) continue;   // idempotent, eine pro Slide
      haengeAn(slides[i], tpl.content.cloneNode(true));
    }
  }

  function hatSchonPille(slide) {
    // Bewusst ueber die direkten Kinder statt ':scope >', das ist in aelteren
    // Safari-Versionen unzuverlaessig.
    var k = slide.children;
    for (var i = 0; i < k.length; i++) {
      if (k[i].classList && k[i].classList.contains('mm-sc-pill')) return true;
    }
    return false;
  }

  /* ---------- 2. Tooltip per Tap ---------- */
  function tooltip() {
    var tip = document.querySelector('.mm-sc-tip');
    var trigger = tip && tip.querySelector('.mm-sc-info');
    if (!tip || !trigger || trigger.dataset.mmScBound) return;
    trigger.dataset.mmScBound = '1';

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var offen = tip.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', offen ? 'true' : 'false');
    });
    // Tap daneben schliesst wieder
    document.addEventListener('click', function (e) {
      if (!tip.contains(e.target)) {
        tip.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        tip.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function start() {
    tooltip();
    setzePille();
    // Bewusst weiterlaufen, nicht beim ersten Erfolg abbrechen: Die Galerie
    // rendert nach und der Koala-Gallery-Sync wechselt die aktive Slide erst
    // danach. setzePille() ist idempotent. 60 x 250ms = 15s, dann ist die
    // Galerie stabil.
    var n = 0;
    var iv = window.setInterval(function () {
      n++;
      setzePille();
      if (n > 60) window.clearInterval(iv);
    }, 250);
    // Wechselt der Nutzer selbst das Bild, kann die Slide der Pille verborgen
    // werden. Kurz danach erneut prüfen.
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.thumbnail-list, .slider-button')) {
        window.setTimeout(setzePille, 220);
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
